// @flow
import type {
  IssuesAction,
} from '../types';

import {
  REFRESH_REQUEST,
  LOAD_SELECT_ISSUES_REQUEST,
} from './actionTypes';

export const refreshIssuesRequest = ({ debouncing }): IssuesAction => ({
  type: REFRESH_REQUEST,
  debouncing,
});

export const loadSelectIssuesOptionsRequest = ({
  query,
  loadedQty,
  resolve,
}): FilterAction => ({
  type: LOAD_SELECT_ISSUES_REQUEST,
  query,
  loadedQty,
  resolve,
});
